import Link from '@/components/Link/Link';
import tw, { styled } from 'twin.macro';

export const StyledLink = styled(Link)`
  ${tw`whitespace-nowrap`}
`;

export const StyledCtaSection = styled.div`
  ${tw`flex flex-col items-center justify-center`}
  ${tw`md:justify-start md:flex-row md:flex-nowrap`}
  ${tw`lg:h-full`}
  ${tw`gap-2`}
  ${tw`pt-[48px] pb-[112px] md:py-0`}
`;
